import { useCallback, useState } from "react";
import InfoIcon from "../../assets/icons/InfoIcon";
import { useBankAccountSearch } from "../../hooks/bankAccount/useBankSearch";
import { ValidationError } from "../../modules/settings/settings";
import { BankData, ProfileBankData } from "../../types";
import { clearFieldError, handleErrors } from "../../utils/handleErrors";
import { SearchInput } from "../common";
import { InputComponent } from "../core/Forms";
import { useNavigate } from 'react-router-dom';
import { createBankAccount } from "../../backend-services";
import toast from 'react-hot-toast';

interface BankAccountStepProps {
    setActiveStep: (step: number) => void;
  }

interface Bank {
    value: string;
    label: string;
  }

const BankAccountStep: React.FC<BankAccountStepProps> = ({  setActiveStep, }) => {


    const [bankName, setBankName] = useState<string | null>(null);
        const [accountName, setAccountName] = useState<string | null>(null);
        const [bankAccounts, setBankAccounts] = useState<ProfileBankData[]>([]);
        const [selectedBank, setSelectedBank] = useState<Bank | null>(null);
        const [, setBankAccount] = useState<Bank[]>([]);
        const [errorMessage, setErrorMessage] = useState<string>('');
        const [isLoading, setIsLoading] = useState(false);
        const navigate = useNavigate();
        const [formData, setFormData] = useState({
            bankName: '',
            accountName: '',
            accountNumber: '',
          })
          
  
  const { bankAccount, isSearching, handleSearch } = useBankAccountSearch();
        const [validationResults, setValidationResults] = useState<ValidationError>({
            bankName: '',
            accountNumber: '',
            accountName: '',
          });

          const handletBankAccountSearch = (searchText: string) => {
            const filteredBanks = bankAccount.filter((bank: { label: string; }) =>
                bank.label.toLowerCase().includes(searchText.toLowerCase())
              );
              setBankAccount(filteredBanks);
             
              clearFieldError(searchText, validationResults, setValidationResults)
            };

            const handleSetBankAccount = (selectedBank: Bank | null) => {
                if (selectedBank) {
                  setFormData((prevData) => ({
                    ...prevData,
                    bankName: selectedBank.label,
                  }));
                  setSelectedBank(selectedBank);
                setValidationResults((prevErrors) => ({
                  ...prevErrors,
                  bankName: '',
                }));
                } else {
                  setFormData((prevData) => ({
                    ...prevData,
                     bankName: '', 
                  }));
                  setSelectedBank(null);
                }
                clearFieldError('selectedBank', validationResults, setValidationResults);
                
              };

              const selected = selectedBank
  ? { value: selectedBank.value, label: selectedBank.label }
  : null;

              const handleInputChange = useCallback(
                (event: React.ChangeEvent<HTMLInputElement>) => {
                  const { name, value } = event.target;
              
                  if (name === 'accountNumber') {
                    const numericValue = value.replace(/\D/g, '');
                    const restrictedValue = numericValue.slice(0, 10);
              
                    setFormData((prevFormData) => ({
                      ...prevFormData,
                      [name]: restrictedValue,
                    }));
                  } else {
                    setFormData((prevFormData) => ({
                      ...prevFormData,
                      [name]: value,
                    }));
                  }
              
                  clearFieldError(name, validationResults, setValidationResults);
                },
                [formData, validationResults],
              );


              const handleCreateBankAccount = async (formData: ProfileBankData) => {
                try {
                  setIsLoading(true);
                  const newBankAccount = await createBankAccount({
                    ...formData,
                    currency: 'NGN',
                    isActive: true,
                  });
                  setBankAccounts((oldAccounts) => [...oldAccounts, newBankAccount]);
                  return true;
                } catch (error) {
                  handleErrors(error, setErrorMessage);
                  return false;
                } finally {
                  setIsLoading(false);
                }
              };
            

              const handlePrevious = () => {
                //@ts-ignore
                setActiveStep((prev: number) => prev - 1);
              };
              const handleNext = async () => {
                if (!isLoading) {
                  const success = await handleCreateBankAccount(formData);
                  if (success) {
                    //@ts-ignore
                    setActiveStep((prev) => prev + 1);
                    navigate(`/welcomePage`);
                  } else {
                    toast.error(errorMessage || 'Unable to create Bank Account. Please try again');
                  }
                }
              };
            
              
              const handleSkip = () => {
                handleNext();
              };


        return (
          <>
          <p className='top-0 right-0 text-[#044E97] flex justify-end text-[16px] mt-[3em] xl:mr-[5em] mr-[2em] biglg:mr-[5em] font-medium' onClick={handleSkip}  style={{ cursor: 'pointer' }}>Skip</p>
            <div className="mt-[5em] 375:ml-0 414:ml-[1em] 360:ml-[-0.6em] md:ml-[-0.1em] bigmd:ml-[1.6em] 540:ml-[4em] 412:ml-[1em] lg:ml-[3em] biglg:ml-[7em] xl:ml-[10em]">
                <h2 className="lg:text-[24px] text-[20px] md:text-[24px] bigmd:text-[24px] text-[#292D32] font-bold"> Bank Account</h2>
                <p className="mb-4 lg:text-[16px] font-light text-[14px] md:text-[16px] bigmd:text-[16px]">Enter bank account details. This will be on all invoices <br/> created for your customer</p>
    
             
        <div className="flex justify-center mt-[32px] xl:ml-[-23em] 360:ml-[0.6em] md:ml-[0.5em] bigmd:ml-[-2em] 540:ml-[-5em] 412:ml-[-1em] lg:ml-[-6em] biglg:ml-[-20em] 2xl:ml-[-28em] 3xl:ml-[-36em] ">
          <div className="xl:w-[430px] w-[350px] md:w-[430px] h-[127px] bg-[#2F80ED] bg-opacity-[0.08] border border-[#2F80ED]  ">
            <div className="flex justify-center">
              <p className="xl:text-[18px] text-[15px] flex gap-[16px] mt-[14px] items-center font-bold text-[#2E2E2E] ">
                <InfoIcon />
                Add Bank Account
              </p>
            </div>
            <div className="flex justify-center mt-[5px] leading-6  ">
              <p className="w-[430px]  text-[12px] text-center text-[#5D6D73] ">
              Simply add your bank information so it will be <br/> readily available for use when creating an invoice.<br/>
You can add three different bank accounts.
              </p>
            </div>
          </div>
        </div>
                <div className="flex flex-col items-center lg:items-start justify-center lg:flex lg:flex-col lg:w-[100%] lg:justify-start lg:gap-[5px] lg:ml-[0.5em]  375:ml-[-2.2em] 414:ml-[-2.2em] 360:ml-[-2.2em] md:ml-[0.2em] bigmd:ml-[-2em] 540:ml-[-7.5em] 412:ml-[-3em] xl:ml-[0.4em]">
            <div className="w-[310px] sm:w-[434px] lg:w-[434px] xl:w-[434px] lg:mt-[21px] lg:mb-6 mt-[35px] sm:mt-[24px] xl:mt-[] mb-[16px] sm:mb-[16px]">
              <label htmlFor="Bank Name" className="lg:block lg:font-sm lg:text-[13px] lg:text-black text-[11px] ">
                Bank Name
              </label>
              <SearchInput 
              data={bankAccount} 
              placeholder="Search Bank Account"
              displayKey="label"
              isLoading={isSearching}
              value={formData.bankName}
              clearIconClass='xl:mr-[1em] mr-[0.5em] lg:mr-[3em]'
              dropdownClassName="xl:w-[434px] w-[300px] md:w-[430px] "
               dropdownStyle={{
                        maxHeight: '800px',
                        overflowY: 'auto',
                      }}
                      emptyMessage={'This bank is not found'}
                      classNames="w-[350px] sm:w-[434px] border border-gray-300 bg-white max-h-[48px] min-h-[48px] placeholder:text-[15.25px] h-[39.77px] rounded p-2 mt-[5px] focus:outline-none focus:shadow-outline appearance-none lg:focus:ring-0 leading-normal xl:w-[434px] lg:w-[434px]"
                      selected={selected}
                      onSelect={handleSetBankAccount}
                      handleChangeText={handletBankAccountSearch }
              />
              {validationResults.bankName && <div className="text-red-500">{validationResults.bankName}</div>}
            </div>
            <div className="w-[310px] sm:w-[434px] lg:w-[434px] lg:h-[48px] mb-[16px] sm:mb-[16px] lg:mb-6">
              <label htmlFor="account number" className="lg:block lg:font-sm lg:text-[13px] lg:text-black text-[11px]  ">
                Account Number
              </label>
              <InputComponent
                placeholder="Account Number"
                name="accountNumber"
                type="number"
                value={formData.accountNumber}
                handleChange={handleInputChange}
                className="w-[350px] sm:w-[434px] lg:w-[434px] xl:w-[434px]"
              />
              {validationResults.accountNumber && <div className="text-red-500">{validationResults.accountNumber}</div>}
            </div>
            <div className="w-[310px] sm:w-[434px] lg:w-[434px] lg:h-[48px] lg:mt-[32px] mb-[32px]">
              <label htmlFor="account name" className="lg:block lg:font-sm lg:text-[13px] lg:text-black text-[11px] ">
                Account Name
              </label>
              <InputComponent
                placeholder="Account Name"
                name="accountName"
                type="text"
                value={formData.accountName}
                handleChange={handleInputChange}
                className="w-[350px] sm:w-[434px] lg:w-[434px] xl:w-[434px]"
              />
              {validationResults.accountName && <div className="text-red-500">{validationResults.accountName}</div>}
            </div>
            <div className='flex gap-[2.5em] ml-[0.3em] mt-[-1em] md:ml-[-0.5em] 540:ml-[2em] lg:mt-[3em] biglg:mt-[5emr]'> 
      <button
       className="bg-[#ffffff] text-[16px]  h-[48px] 540:mr-[em] w-[112px] border-[#044E97] rounded-md text-[#044E97] ml:[2em] md:mr-[-1.5em] mt-[2.7em] md:mt-[2.9em] xl:mt-[2em] md:w-[215px] lg:mr-[-0.5em]  lg:mt-[-2em] xl:w-[200px] xl:mr-[-0.5em] mb-[2em]"
        onClick={handlePrevious}
      >
        Previous Step
      </button>
      <button
        className="bg-[#044E97] text-[16px]  h-[48px] 540:mr-[em] w-[112px]  rounded-md text-[#ffffff] ml:[2em] md:mr-[-1.5em] mt-[2.7em] md:mt-[2.9em] xl:mt-[2em] md:w-[215px] lg:mr-[-0.5em]  lg:mt-[-2em] xl:w-[200px] xl:mr-[-0.5em] mb-[2em]"
        onClick={handleNext}
        disabled={isLoading}
      >
     {isLoading ? 'Loading...' : 'Next Step'}
      </button>
      </div>

            </div>
            </div>
            </>
        );
    }
    
    export default BankAccountStep;
    